// extracted by mini-css-extract-plugin
export default {"alumniWrapper":"Alumni_alumniWrapper__RMt2D","alumniGrid":"Alumni_alumniGrid__89Q-t"};